module.exports = __webpack_public_path__ + "img/root011.0c409637.png";